export const dashboardData = {
  summary: {
    activeClients: 28,
    activeProjects: 16,
    suppliers: 12,
    workersOnSite: 48,
    revenue: 850000
  },

  monthlyClients: [5, 10, 14, 18, 22, 28],

  projectTypes: {
    residential: 8,
    commercial: 4,
    villa: 2,
    office: 2
  },

  resources: {
    suppliers: 12,
    workers: 48
  }
};
